<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <h2 class="card-title-desc">Manual Statements</h2>
          <TableLoading v-if="institutions.page === 0"/>
          <div v-else>
            <data-table :columns="customersColumns" :rows="institutions.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <template v-slot:actions="slotProps">
                <b-button variant="info" size="sm" class="py-1 text-white" @click="viewCustomerOrders(slotProps.row.publicId)">
                  View Orders
                </b-button>
              </template>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="institutions.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import {ALL_CUSTOMERS} from "@/gql";
import TableLoading from "@/components/TableLoading";

export default {
  page: {
    title: "Manual Statements",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "manual-statements",
  data() {
    return {
      title: "Manual Statements",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Manual Statements",
          active: true
        }
      ],
      customersColumns: [
        {
          field: 'customerTier',
          label: 'Tier'
        },
        {
          field: 'typeId',
          label: 'Category'
        },
        {
          field: 'institutionCode',
          label: 'Customer Code'
        },
        {
          field: 'name',
          label: 'Customer Name'
        },
        {
          field: 'activeState',
          label: 'Status'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      institutions: {
        page: 0,
        objects: []
      },
    }
  },
  apollo: {
    institutions: {
      query: ALL_CUSTOMERS,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    viewCustomerOrders(public_id){
      this.$router.push(routeItems.single_customer_orders_route+'/'+public_id)
    },
    searchFn(data){
      this.searchKeyword = data
    }
  }
}
</script>

<style scoped>

</style>
